import strings from 'strings';

export const COPIES = strings.inventory.quickEntry.drawers.jobOrder;
export const DELETE_API_VERSION = 1;

export const FORM_FIELDS = {
  position: 'position',
  hiringAuthorityName: 'hiringAuthorityName',
  companyName: 'companyName',
  notes: 'notes',
  files: 'files'
};

export const DEFAULT_FORM_VALUES = {
  [FORM_FIELDS.position]: '',
  [FORM_FIELDS.hiringAuthorityName]: '',
  [FORM_FIELDS.companyName]: '',
  [FORM_FIELDS.notes]: COPIES.notesTemplate,
  [FORM_FIELDS.files]: {}
};

export const UPLOAD_CATEGORIES = [
  { id: 49, title: COPIES.uploads.resume },
  { id: 50, title: COPIES.uploads.assignmentDataSheet },
  { id: 51, title: COPIES.uploads.handwrittenNotes }
];
